var React = require('react');

function Deselected (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 0L20 10H4L12 0ZM20 14H4L12 24L20 14Z","fill":"currentColor"}));
}

Deselected.defaultProps = {"viewBox":"0 0 24 24","fill":"none","style":{"color":"#39424A"}};

module.exports = Deselected;

Deselected.default = Deselected;
